<template>
    <app-layout title="Dashboard">
        <template v-slot:header>
            <div class="flex justify-between">
                <h2 class="font-bold text-4xl dark:text-gray-200">
                    Welcome to jumpthink, {{ $page.props.user.name }}!
                </h2>
                <inertia-link v-if="canManageSurveys && tenant"
                              :href="route('tenant.survey.create', tenant.id)"
                              class="max-w-min whitespace-nowrap px-4 py-2 flex items-center text-lg font-normal leading-5 rounded-md text-white border border-transparent focus:outline-none focus:shadow-none disabled:opacity-25 transition transition-all duration-150 bg-red-0 hover:bg-red-0h">
                    Create survey
                    <span class="ml-2 text-white" aria-hidden="true">+</span>
                </inertia-link>
            </div>
        </template>

        <super-admin-dashboard v-if="isSuperAdmin"></super-admin-dashboard>
        <survey-admin-dashboard v-if="tenant && canManageSurveys" :recent-surveys="recentSurveys"></survey-admin-dashboard>

    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import SuperAdminDashboard from '@/Components/SuperAdminDashboard';
import SurveyAdminDashboard from '@/Components/SurveyAdminDashboard';
import JetButton from '@/Jetstream/Button';
import {usePage} from "@inertiajs/inertia-vue3";

export default defineComponent({
    components: {
        AppLayout,
        SuperAdminDashboard,
        SurveyAdminDashboard,
        JetButton,
    },
    props: {
        recentSurveys: Object,
    },
    setup() {
        const canManageSurveys = usePage().props.value.allUserPermissions
            && usePage().props.value.allUserPermissions.indexOf('manage surveys') !== -1;

        const tenant = usePage().props.value.tenant;

        const isSuperAdmin = usePage().props.value.user?.roles.some((role) => role.name === "Super Admin");

        return {
            canManageSurveys,
            tenant,
            isSuperAdmin,
        }
    }
})
</script>
